import { Text, useColorMode, useColorStyle } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Info } from '@Components/Common/Info';

export default function TimezoneTip({ timezoneOffset = '+00:00' }) {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();
  return (
    <>
      <Text ml="2x" color={colorStyle.color.secondary}>
        UTC {timezoneOffset}
      </Text>
      <Info
        content={t('reportCommon.tips.hints.scheduleTimezone')}
        iconStyle={{ ml: '2x', mt: '2px' }}
      />
    </>
  );
}
